function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { useAction } from 'hooks';
import App from 'modules/App';
const getLabel = (item, messages)=>{
    if (!messages || !messages[item]) return item;
    if (isString(messages[item])) return messages[item];
    return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages[item]));
};
const Tab = ({ item, activeItem, itemsData, messages, errors, modified, action })=>{
    const isNavigationBlocked = useSelector(App.selectors.isNavigationBlocked);
    const openModal = useAction(App.actions.openModal, App.constants.UNSAVED_CHANGES_MODAL);
    const label = getLabel(item, messages);
    const counter = get(itemsData, [
        item,
        'counter'
    ]);
    const counterChip = isNumber(counter) ? /*#__PURE__*/ _jsx("span", {
        className: "tab__counter",
        children: counter
    }) : null;
    const onClick = (evt)=>{
        evt.preventDefault();
        if (isNavigationBlocked) {
            openModal();
            return;
        }
        action(item);
    };
    return /*#__PURE__*/ _jsx("li", {
        className: cn('tab', {
            'tab--active': item === activeItem,
            'tab--error': errors && errors[item]
        }),
        children: /*#__PURE__*/ _jsxs("a", {
            href: "",
            onClick: onClick,
            children: [
                label,
                modified && modified[item] && '*',
                counterChip
            ]
        })
    });
};
const Tabs = (_0)=>{
    let { items } = _0, props = _object_without_properties(_0, [
        "items"
    ]);
    const renderTab = (item)=>/*#__PURE__*/ _jsx(Tab, _object_spread({
            item: item
        }, props), item);
    return /*#__PURE__*/ _jsx("div", {
        className: "tabs",
        children: items.map(renderTab)
    });
};
export default Tabs;
